import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center" }

import { reactive, ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import type { FormInstance } from "element-plus";
import PaymentService from "../../services/PaymentService";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateRefund',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const t = useI18n().t;
const isLoading = ref(true);
const modalRef = ref<InstanceType<typeof SimpleForm>>();
const staticId = ref(false);
const ruleFormRef = ref<FormInstance>();
const rules = reactive<any>({
  targetId: [
    { required: true, message: "Please input wallet ID", trigger: "blur" },
  ],
  amount: [{ required: true, message: "Please input amount", trigger: "blur" }],

  comment: [
    { required: true, message: "Please input comment", trigger: "blur" },
  ],
});

const formData = ref<any>({
  targetId: 0,
  targetType: 1,
  amount: 0,
  comment: "",
});

const show = async (_targetId = 0) => {
  isLoading.value = true;
  modalRef.value?.show();
  //   resetForm();
  if (_targetId != 0) {
    staticId.value = true;
  }
  formData.value.targetId = _targetId;
  isLoading.value = false;
};

const hide = () => {
  modalRef.value?.hide();
};

const submit = async () => {
  if (!ruleFormRef.value) return;

  let isValid = false;
  await ruleFormRef.value.validate(async (valid) => {
    isValid = valid;
  });
  if (!isValid) return;

  try {
    await PaymentService.createRefund({
      ...formData.value,
      amount: formData.value.amount * 100,
    });
    emits("eventSubmit");
    MsgPrompt.success("success");
    hide();
  } catch (error) {
    //if res.data[0].id is null or undefined then account not found
    MsgPrompt.error(error);
  }
};

// const resetForm = () => {
//   if (!ruleFormRef.value) return;
//   ruleFormRef.value.resetFields();
// };



__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _unref(t)('action.createRefund'),
    "is-loading": isLoading.value,
    submit: submit,
    style: {"width":"380px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: formData.value,
            rules: rules,
            "label-width": "100px",
            class: "demo-ruleForm",
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.walletId'),
                prop: "targetId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.targetId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.targetId) = $event)),
                    disabled: staticId.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.amount'),
                prop: "amount"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: formData.value.amount,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.amount) = $event)),
                    precision: 2
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('action.comment'),
                prop: "comment"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.comment,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.comment) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})